import { FloatingLabel, Form } from 'react-bootstrap';
import { useFormContext, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { NumericFormat } from 'react-number-format';
import { getError, removeNumbers } from './FormHelpers';
import { ReactNode } from 'react';
import { trackField } from 'merchant-components';
import { useWizardFormContext } from '@odmonorepo/core-components';

interface FormNumericInputProps {
  name: string;
  label: ReactNode;
  suffix?: string;
  min?: number;
  max?: number;
  className?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  'data-testid'?: string;
  readOnly?: boolean;
}

export const FormNumericInput = ({
  name,
  label,
  min,
  max,
  className,
  readOnly = false,
  'data-testid': dataTestId,
  ...numericFormatProps
}: FormNumericInputProps) => {
  const { control, trigger } = useFormContext();
  const { formName } = useWizardFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value } }) => (
        <FloatingLabel
          controlId={name}
          label={label}
          className={className}
        >
          <NumericFormat
            inputMode="numeric"
            {...numericFormatProps}
            className={`form-control ${getError(name) ? 'is-invalid' : ''}`}
            id={name}
            name={name}
            data-testid={dataTestId}
            readOnly={readOnly}
            value={value || ''}
            isAllowed={(values) => {
              if (!values.value) return true;
              if (max !== undefined && values.floatValue !== undefined && values.floatValue > max) return false;
              return true;
            }}
            onValueChange={(v) => {
            let numValue = v.value ? Number(v.value) : undefined;
            if (numValue !== undefined) {
              if (max !== undefined && numValue > max) numValue = max;
              if (min !== undefined && numValue < min) numValue = min;
            }
            onChange(numValue);
            trigger(name);
          }}
            onBlur={() => {
              trackField(
                formName,
                name,
                'Blur'
              );
              onBlur();
            }}
          />
          <Form.Control.Feedback type="invalid">
            <FormattedMessage id={'formInput.' + removeNumbers(name) + '.error'} />
          </Form.Control.Feedback>
        </FloatingLabel>
      )}
    />
  );
};

export default FormNumericInput;
